import { render, staticRenderFns } from "./tokenauthorization.vue?vue&type=template&id=3ee2ca12&"
import script from "./tokenauthorization.vue?vue&type=script&lang=js&"
export * from "./tokenauthorization.vue?vue&type=script&lang=js&"
import style0 from "./tokenauthorization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports